module.exports = __webpack_public_path__ + "static/media/login-img.d54ce94b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-img.jpg
// module id = 367
// module chunks = 33